<template>
  <div class="Code">
    <div class="page-title">{{$t('lang.title_code')}}</div>
    <div>
      <ATable
        ref="table"
        hideButtonExcel
        hide-button-insert
        hide-pagination
        :data="items"
        :loading="loading"
        border                
        @row-click="handleClickRow"        
      >
        <el-table-column
          type="index"
          :label="$t('lang.No')"
          align="center"
          :width="$width.index"
        />
        <el-table-column prop="name" :formatter="lang" :label="$t('lang.code_type')" width="200" />
        <el-table-column
          prop="details"
          :label="$t('lang.code_rule')"
          :formatter="formatDetails"
          show-overflow-tooltip
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="코드 규칙 사용자 정의"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <CodeForm ref="form" 
        :data="form_data" 
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import CodeForm from "./CodeForm";

export default {
  name: "Code",
  mixins: [form_container, authority_level],
  components: { CodeForm },
  data() {
    return {
      items: [],
      dialogVisible: false,
      loading: false,
      form_data: undefined
    };
  },
  computed: {       
    has_grant_write() {      
      return this.isWriteLevel('code');
    },
  },
  created() {
    this.init();
  },
  methods: {
    /** 초기화 */
    init() {
      this.loadData();
    },
    /** get code */
    loadData() {
      this.loading = true;
      this.api.listCode().then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, res.message);
        }
        this.items = res.data;
      });
    },
    lang(row, column, cellValue) {
      return this.$t("lang." + cellValue);
    },
    compare(property) {
      return function(a, b) {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
      };
    },
    /** 생성규칙 포멧 */
    formatDetails: function(row, cell, cellValue) {
      if (cellValue.length > 0) {
        let details = cellValue.slice().sort(this.compare("seq"));
        details = details.map(detail => {
          let type = detail.type;
          let length = detail.length;
          let text;

          switch (type) {
            case "f":
              text = detail.text;
              return "고정문자(" + text + ")";
            case "y":
              return "연도(" + length + ")자리";
            case "m":
              return "월(" + length + ")자리" + (length === 1 ? " 알파벳" : "");
            case "d":
              return "일(" + length + ")자리";
            case "s":
              return "일련번호(" + length + ")자리";
          }

          return "";
        });

        return details.join(" + ");
      }

      return cellValue;
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      // if (!this.has_grant_write) { return; }
      this.openDialog(data);
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = this.util.looseClone(data);
      if (clone.details.length > 0) {
        clone.details = clone.details.sort(this.compare("seq"));
      }
      this.form_data = clone;
      this.dialogVisible = true;
    },
    /**  폼 처리 완료 */
    handleCompleted(action, message) {
      switch (action) {
        case "save":
          this.dialogVisible = false;
          this.loadData();
          break;
      }

      if (!message) {
        return;
      }
      this.$notify(message);
    }, 
  },  
};
</script>